
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex'
export default {
    async fetch() {
        console.log('this.search', this.$route)
        await this.getSearchListing()
    },
    auth: false,
    data() {
        return {
            firstTime: true,
            showPriceCheckButton: false,
            showPrice: false,
            searchTab: false,
            selectedSearchTab: null,
            showType: false,
            propertyTypeId: null,
            minPrice: {
                name: 'No Min',
                value: 1,
                displayValue: 'No Min'
            },
            maxPrice: {
                name: 'No Min',
                value: 1000000000000000,
                displayValue: 'No Min'
            },
            // keyword:this.$route.query.keyword,
            listings: [],
            listingsDatForMap: [],
            latLng: {
                lat: null,
                lng: null
            },
            coordinates: [],
            geoBoundaries: null,
            windowHeight: 500,
            selectSearchText: null,
            hideMap: false,
            formattedAddress: null,
            searchObj: {
                // "keyword": null,
                geoBoundaries:null,
                "polygon": [],
                "location": this.latLng,
                "propertyListingTypeId": null,
                "propertyTypeId": null,
                "minPrice": null,
                "maxPrice": null,
                zoomLevel: 10
            },
            pageInfo: {
                currentPage: 1,
                itemsPerPage: 12,
                itemsTotal: 3,
                pages: 1
            },
            placeId:this.$route.query.placeId
        }
    },
    mounted() {
        // if (window.google) {
        //   this.initialize()
        // }
        this.$nextTick(function () {
            this.getWindowHeight()
        })
        window.addEventListener('resize', this.getWindowHeight)
        this.selectedSearchTab = this.taxonomy.propertyListingType.filter(el => el.id == parseInt(this.$route.query.propertyListingTypeId))[0],
            console.log("this.selectedSearchTab", this.selectedSearchTab)
        if (this.$route.query.maxPrice) {
            this.maxPrice = this.taxonomy.price[this.selectedSearchTab.name == 'For Rent' ? 'rent' : 'sale'].maxPrice.filter(el => JSON.parse(this.$route.query.maxPrice) === el.value)[0]
        }
        if (this.$route.query.minPrice) {
            this.minPrice = this.taxonomy.price[this.selectedSearchTab.name == 'For Rent' ? 'rent' : 'sale'].minPrice.filter(el => JSON.parse(this.$route.query.minPrice) === el.value)[0]
        }
        if (this.$route.query.placeId) {
            this.getPollygunFromServer()
        }else{
            this.getSearchListing()
        }

        console.log("this.maxPrice", this.maxPrice)
        console.log("this.minPrice", this.minPrice)

        // if(this.$breakpoint.is.mobile){
        //   this.hideMap=true
        // }else{
        //   this.hideMap=false
        // }

    },
    computed: {
        ...mapGetters('home', ['searchParam']),
        ...mapState('taxonomy', ['taxonomy']),
    },
    watch: {
        '$route.query.lat': {
            immediate: true,
            handler(val) {
                console.log("router changed lat", this.$route.query.lat)
                this.latLng.lat = JSON.parse(this.$route.query.lat)
            }
        },
        '$route.query.lng': {
            immediate: true,
            handler(val) {
                console.log("router changed lng", this.$route.query.lng)
                this.latLng.lng = JSON.parse(this.$route.query.lng)
            }
        },
        '$route.query.propertyListingTypeId'() {
            // this.$nextTick(() => {
            //   this.range[0]=JSON.parse(this.$route.query.propertyListingTypeId)===161?100000 :1000,
            //   this.range[1]=JSON.parse(this.$route.query.propertyListingTypeId)===161? 250000000:500000
            //   this.$forceUpdate()
            // })
            this.getSearchListing()

        },
        propertyTypeId() {
            console.log("propertyTypeId", this.propertyTypeId, this.firstTime)
            if (!this.firstTime) {
                let parms = `?&propertyListingTypeId=${this.selectedSearchTab.id}&lat=${this.latLng.lat}&lng=${this.latLng.lng}&propertyTypeId=${this.propertyTypeId.id}}`

                if (this.minPrice.value) {
                    parms = parms + `&minPrice=${this.minPrice.value}`
                }

                if (this.minPrice.value) {
                    parms = parms + `&maxPrice=${this.maxPrice.value}`
                }
                this.$router.replace(this.localeRoute(`/search${parms}`))
                this.getSearchListing()
            }
        },
        maxPrice() {
            this.setPrice()
        },
        minPrice() {
            this.setPrice()
        }
    },
    methods: {
        ...mapActions('map', ['placeDetails']),
        ...mapActions('home', ['search', 'searchMap']),
        whatisthischange(ev) {

            console.log("ev whatisthischange", ev)
            let parms = `?propertyListingTypeId=${ev.id}&lat=${this.latLng.lat}&lng=${this.latLng.lng}`
            if (this.propertyTypeId) {
                parms = parms + `&propertyTypeId=${this.propertyTypeId.id}`
            }
            if (this.minPrice.value) {
                parms = parms + `&minPrice=${this.minPrice.value}`
            }

            if (this.minPrice.value) {
                parms = parms + `&maxPrice=${this.maxPrice.value}`
            }
            this.$router.replace(this.localeRoute(`/search${parms}`))
        },
        getCoordinatesLatLng(ev) {

            this.coordinates = ev
            console.log('this.getCoordinatesLatLng in search', this.coordinates)
            if (ev.length) {
                this.geoBoundaries=null
                this.searchObj.geoBoundaries=null
                this.getSearchListing()
            }
        },
        searchThisArea(ev) {
            console.log('searchThisArea', ev)

            this.mapChangesFromAutoComplete(ev)

        },
        setPrice() {
            console.log("this.selectedSearchTab", this.selectedSearchTab)
            let parms = {
                propertyListingTypeId: this.selectedSearchTab.id,
                lat: this.latLng.lat,
                lng: this.latLng.lng

            }
            // `?&propertyListingTypeId=${this.selectedSearchTab.id}&lat=${this.latLng.lat}&lng=${this.latLng.lng}`
            if (this.propertyTypeId) {
                parms.propertyTypeId = this.propertyTypeId.id
            }
            if (this.minPrice.value) {
                parms.minPrices = this.minPrice.value
            }

            if (this.minPrice.value) {
                parms.maxPrice = this.maxPrice.value
            }
            console.log("this.maxPrice", this.maxPrice)
            console.log("parms", parms)
            this.$router.push({
                path: this.$route.fullPath,
                query: parms
            })
            // this.getSearchListing()
        },
        async mapZoomChange(ev) {
            console.log("vmapZoomChange vev", ev)
            this.searchObj.zoomLevel = ev
            await this.getSearchListing()
        },
        async getSearchListing() {

            this.selectedSearchTab = await this.taxonomy.propertyListingType.filter(el => el.id == parseInt(this.$route.query.propertyListingTypeId))[0]

            console.log('getSearchListing', this.coordinates)

            if (this.latLng.lat && this.latLng.lng && !this.geoBoundaries && !this.coordinates.length) {
                this.searchObj.location = {
                    "lat": this.latLng.lat,
                    "lng": this.latLng.lng
                }
                this.searchObj.radius = 0
                this.searchObj.polygon = []
                this.searchObj.geoBoundaries=null
                console.log("this.latLng.lat && this.latLng.lng.length this.searchObj", this.searchObj)
            } else {
                this.searchObj.radius = 0
                this.searchObj.location = null
                console.log("else this.latLng.lat && this.latLng.lng.length this.searchObj", this.searchObj)
            }
            if (this.coordinates.length) {
              this.searchObj.location = {
                    "lat": this.coordinates[0].lat,
                    "lng": this.coordinates[0].lng
                }
                this.searchObj.radius = this.coordinates[0].radius
                this.searchObj.polygon = []
                this.searchObj.geoBoundaries=null
                console.log("this.coordinates.length this.searchObj", this.searchObj)
            }
            if (this.geoBoundaries) {
                this.searchObj.geoBoundaries = this.geoBoundaries
                this.searchObj.location = null
                this.searchObj.polygon = []
                this.searchObj.radius = 0
                console.log("this.geoBoundaries.length this.searchObj", this.searchObj)
            }
            if (this.propertyTypeId) {
                this.searchObj.propertyTypeId = this.propertyTypeId.id
            }
            if (this.selectedSearchTab) {
                this.searchObj.propertyListingTypeId = this.selectedSearchTab.id
            }
            if (this.minPrice.value) {
                this.searchObj.minPrice = this.minPrice.value
            }
            if (this.minPrice.value) {
                this.searchObj.maxPrice = this.maxPrice.value
            }
            console.log("this.searchObj", this.searchObj)
            await this.getSearchMap()
            await this.searchForListingCard()
        },
        async searchForListingCard() {
            if (process.client) {
                this.$nuxt.$loading.start()
            }
            this.search({
                obj: this.searchObj,
                pageInfo: this.pageInfo
            }).then(res => {

                console.log('getSearchListing', res)
                this.listings = res.data
                this.pageInfo = res.pageInfo
                if (process.client) {
                    this.$nuxt.$loading.finish()
                    this.firstTime = false
                }

            }).catch(err => {
                if (process.client) {
                    this.$nuxt.$loading.finish()
                    this.firstTime = false
                }
            })
        },
        async getSearchMap() {
            this.searchMap({
                obj: this.searchObj,
                pageInfo: this.pageInfo
            }).then(res => {
                console.log('getSearchListing', res)
                this.listingsDatForMap = res.data
                // this.pageInfo = res.pageInfo
                if (process.client) {
                    this.$nuxt.$loading.finish()
                    this.firstTime = false
                }

            }).catch(err => {
                if (process.client) {
                    this.$nuxt.$loading.finish()
                    this.firstTime = false
                }
            })
        },
        getWindowHeight() {
            this.windowHeight = document.documentElement.clientHeight - 260
        },
        callsomething() {
            console.log("callsomething")
        },
        mapChangesFromAutoComplete(ev) {

            console.log('mapChangesFromAutoComplete', ev)
            this.placeId = ev
            let parms = `?&propertyListingTypeId=${this.selectedSearchTab.id}&lat=${this.latLng.lat}&lng=${this.latLng.lng}&placeId=${this.placeId}`;
            if (this.propertyTypeId) {
                parms = parms + `&propertyTypeId=${this.propertyTypeId.id}`
            }
            if (this.minPrice.value) {
                this.searchObj.minPrice = this.minPrice.value
            }
            if (this.minPrice.value) {
                this.searchObj.maxPrice = this.maxPrice.value
            }
            this.$router.replace(this.localeRoute(`/search${parms}`))
            // this.$router.replace(`/search?keyword=${this.keyword}&area=${this.$route.query.area}&lat=${ev.lat}&lng=${ev.lng}`)
            //Make it trick to load listing on the map area

            // setTimeout(() => {
            // this.getSearchListing()
            // }, 2000);
            this.getPollygunFromServer()
        },

        toggleMap() {

            this.hideMap = !this.hideMap
            console.log("hide map clicked?", this.hideMap)
        },
        setPage(ev) {
            this.pageInfo.currentPage = ev
            this.getSearchListing()
        },
        async getPollygunFromServer() {
            this.placeDetails({
                    placeId: this.placeId
                }).then(data => {
                    this.coordinates=[]
                    this.searchObj.polygon=[]
                    console.log("data placeDetails", data.result)
                    this.geoBoundaries=data.result.geoBoundaries
                    this.$forceUpdate()
                    this.latLng.lat=data.result.geometry.location.lat
                    this.latLng.lng=data.result.geometry.location.lng
                    this.getSearchListing()
                }).catch(err => {
                    console.log(err)
                })
                .finally(() => (this.isLoading = false))
        }
    },
}
